// Module
var code = "<div class=\"accordion-pane\"><div class=\"accordion-pane-header\" ng-transclude=\"header\"></div><div class=\"accordion-pane-container\" ng-transclude ng-class=\"{'open': vm.open, 'collapsed': !vm.open}\"></div></div>";
// Exports
var _module_exports =code;;
var path = 'app/components/accordion/pane/accordion-pane.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;